<template>

    <div class="page" >

        <toolbar-system v-if="adminManutencao"></toolbar-system>
        <progress-system :isLoad="progress"></progress-system>
        <alertbar-system v-if="AlertbarShow != null" :alertbar="AlertbarShow" v-show="!adminManutencao"></alertbar-system>
            <v-container v-if="manutencoesAtivas!=''">
                <v-layout wrap>
                    <v-flex v-for="manutencaoAtiva in manutencoesAtivas" :key="manutencaoAtiva.index" xs12 >
                        <v-card class="animated fadeIn">
                            <v-card-text>
                                <v-layout>
                                    <v-flex xs2 style="text-align:center" width="100%" v-show="adminManutencao">
                                        <v-card-text >
                                            ID da Manutenção: {{manutencaoAtiva.IdManutencao}}
                                        </v-card-text>

                                        <v-chip color="orange" outline dark style="width:70%;text-align:center">
                                                Em andamento
                                        </v-chip>
                                    </v-flex>

                                    <v-flex xs10>
                                        <v-card-text v-show="adminManutencao">
                                            Justificativa: {{manutencaoAtiva.Justificativa}}
                                        </v-card-text>

                                        <v-card-title class="text-center" v-show="!adminManutencao">
                                            <h3 class="text-center font-weight-medium"> O sistema está em manutenção </h3>

                                        </v-card-title>

                                        <v-card-text v-show="!adminManutencao">
                                            A DATACOM informa que o sistema encontra-se em manutenção. Você pode conferir abaixo a data e o horário previstos para o retorno do sistema. Agradecemos pela compreensão.
                                        </v-card-text>

                                        <v-chip color="orange" outline dark>
                                            <v-icon left>mdi mdi-clock-alert</v-icon>
                                            <div class="text-truncate">{{ $moment(manutencaoAtiva.DataInicial).format('LL') }} - {{ manutencaoAtiva.HoraInicial }}</div>
                                        </v-chip>
                                        <v-chip color="green" outline dark>
                                            <v-icon left>mdi mdi-clock</v-icon>
                                            <div class="text-truncate">{{ $moment(manutencaoAtiva.DataFinal).format('LL') }} - {{ manutencaoAtiva.HoraFinal  }}</div>
                                        </v-chip>
                                        <v-card-actions v-show="adminManutencao">
                                            <v-btn class="blue" @click="[encerrarManutencao(manutencaoAtiva.IdManutencao)]" dark>Encerrar manutenção</v-btn>
                                        </v-card-actions>
                                    </v-flex>

                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
            <v-container v-else v-show="adminManutencao">
                <v-alert :value="true"  class="animated flipInX" color="blue" >
                    Não há nenhuma manutenção em andamento!
                </v-alert>
            </v-container>
        <v-container class="animated fadeIn" v-show="novaManutencao">
            <v-layout align-center justify-center wrap>
                <v-flex xl12>
                    <v-card>
                        <v-card-title>
                            <h4 class="display-1 text-uppercase" v-show="btnManutencaoCadastrar">Nova Manutenção</h4>
                            <h4 class="display-1 text-uppercase" v-show="btnManutencaoEditar">Editar Manutenção</h4>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-form>
                                <v-layout row>
                                    <v-menu
                                            v-model="menu"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            max-width="290px"
                                            color="blue"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                    v-model="manutencao.datainicial"
                                                    label="Data de início da manutenção"
                                                    readonly
                                                    v-on="on"
                                                    color="blue"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker locale="pt-br" color="blue" v-model="manutencao.datainicial" @input="menu = false"></v-date-picker>
                                    </v-menu>
                                    <v-menu
                                            v-model="menu2"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                    label="Data de encerramento da manutenção"
                                                    v-model="manutencao.datafinal"
                                                    readonly
                                                    v-on="on"
                                                    color="blue"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker locale="pt-br" color="blue" v-model="manutencao.datafinal" @input="menu2 = false"></v-date-picker>
                                    </v-menu>
                                </v-layout>
                                <v-layout row>
                                    <v-menu
                                            ref="menu"
                                            v-model="modal"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            :return-value.sync="manutencao.horainicial"
                                            transition="scale-transition"
                                            offset-y
                                            max-width=290px
                                            color="blue"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field cols="5"
                                                          v-model="manutencao.horainicial"
                                                          label="Escolha o horário inicial"
                                                          readonly
                                                          v-on="on"
                                                          color="blue"
                                            ></v-text-field>
                                        </template>
                                        <v-time-picker
                                                v-if="modal"
                                                v-model="manutencao.horainicial"
                                                @click:minute="$refs.menu.save(manutencao.horainicial)"
                                                format="24hr"
                                                color="blue"
                                        ></v-time-picker>
                                    </v-menu>

                                    <v-dialog
                                            ref="dialog"
                                            v-model="modal2"
                                            :return-value.sync="manutencao.horafinal"
                                            persistent
                                            max-width=290px
                                            color="blue"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field cols="5"
                                                          v-model="manutencao.horafinal"
                                                          label="Escolha o horário de encerramento"
                                                          readonly
                                                          v-on="on"
                                                          color="blue"
                                            ></v-text-field>
                                        </template>
                                        <v-time-picker
                                                v-if="modal2"
                                                v-model="manutencao.horafinal"
                                                format="24hr"
                                                color="blue"
                                        >
                                            <v-spacer></v-spacer>
                                            <v-btn text color="blue" @click="modal2 = false">Cancel</v-btn>
                                            <v-btn text color="blue" @click="$refs.dialog.save(manutencao.horafinal)">OK</v-btn>
                                        </v-time-picker>
                                    </v-dialog>
                                    <v-checkbox v-model="manutencao.status" cols="2" color="blue" label="Em andamento"></v-checkbox>
                                </v-layout>
                                <v-textarea v-model="manutencao.justificativa" label="Justificativa" color="blue"></v-textarea>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn @click="[novaManutencao = false, btnManutencaoEditar = null, btnManutencaoCadastrar = null]" class="silver" large dark>
                                Cancelar
                            </v-btn>
                            <v-btn v-if="btnManutencaoCadastrar == true" @click="cadastrarManutencao()" class="blue" large dark>
                                Cadastrar
                            </v-btn>
                            <v-btn v-else @click="atualizarManutencao(manutencao.id)" class="blue" large dark>
                                Atualizar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
           <v-container v-show="adminManutencao">
                <v-flex xl12>
                    <v-card flat>
                        <v-card-title>
                            <v-autocomplete
                                    color="blue"
                                    label="Manutenções"
                                    :items="manutencoes"
                                    item-text="DataInicial"
                                    item-value="IdManutencao"
                                    prepend-icon="mdi mdi-database-search"
                                    @change="getManutencaoSearch($event)"
                            ></v-autocomplete>
                            <v-btn
                                    dark
                                    color="blue"
                                    @click="novaManutencao = !novaManutencao;
                                    btnManutencaoCadastrar = !btnManutencaoCadastrar;"

                            >
                                <v-icon left>mdi mdi-plus</v-icon>Iniciar manutenção
                            </v-btn>
                        </v-card-title>
                        <v-card-text>
                            <v-list>
                                <template v-for="manutencao in manutencoes">
                                    <v-list-tile :key="manutencao.index" :id="manutencao.IdManutencao">
                                        <v-list-tile-action class="text-truncate" style="min-width: 10%">
                                            <v-chip style="width: 100%" class="chip text-center" v-if="manutencao.Status == 1" color="green" outline>Andamento</v-chip>
                                            <v-chip style="width: 100%" class="chip text-center" v-else color="orange" outline>Encerrada</v-chip>
                                        </v-list-tile-action>
                                        <v-list-tile-content class="text-truncate">
                                        <v-card-text>
                                            {{ $moment(manutencao.DataInicial).format('LL') }} às {{ manutencao.HoraInicial }}
                                            <div>
                                             {{manutencao.Justificativa}}
                                            </div>
                                        </v-card-text>
                                        </v-list-tile-content>
                                        <v-list-tile-action>
                                            <v-btn @click="[editarManutencao(manutencao.IdManutencao), btnManutencaoCadastrar = null, novaManutencao = true, btnManutencaoEditar = true]" color="orange" dark icon>
                                                <v-icon>mdi mdi-pencil</v-icon>
                                            </v-btn>
                                        </v-list-tile-action>
                                        <v-list-tile-action>
                                            <v-btn @click="deleteManutencao(manutencao.IdManutencao)" color="red" dark icon>
                                                <v-icon>mdi mdi-delete</v-icon>
                                            </v-btn>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                    <v-divider :key="manutencao.index"></v-divider>
                                </template>
                            </v-list>
                         </v-card-text>
                    </v-card>
                </v-flex>
            </v-container>
        </div>
</template>

<script>
    import ToolbarSystem from "../../../components/ToolbarSystem";
    import ProgressSystem from "../../../components/ProgressSystem";
    import AlertbarSystem from "../../../components/AlertbarSystem";

    export default {
        components: {
            ToolbarSystem,
            ProgressSystem,
            AlertbarSystem
        },
        data() {
            return {
                progress: true,
                AlertbarShow: null,
                sideIcon: true,
                manutencao: {
                    datainicial : null,
                    datafinal : null,
                    horainicial : null,
                    horafinal: null,
                    justificativa: null,
                    status: null
                },
                modal: false,
                modal2: false,
                manutencoes: null,
                menu: false,
                menu2: false,
                novaManutencao: false,
                date: new Date().toISOString().substr(0, 10),
                btnManutencaoEditar: null,
                btnManutencaoCadastrar: false,
                manutencaoAtiva:{
                    datainicial : null,
                    datafinal : null,
                    horainicial : null,
                    horafinal: null,
                    justificativa: null,
                    status: null
                },
                manutencoesAtivas : null,
                adminManutencao: false
            }
        },
        methods:{
            getManutencao(){
                this.axios.get('admin/servicosAll').then(res => {
                    this.manutencoes = res.data
                }).finally(() => {
                    this.progress = false
                })
            },
            getManutencaoAtiva(){
                this.axios.get('admin/servicos').then(res => {
                    this.manutencoesAtivas = res.data
                    if(this.$route.path=='/manutencao' && this.manutencoesAtivas==''){
                        location.href="/"
                    }
                }).finally(() => {
                    this.progress = false
                })
            },
            cadastrarManutencao(){
                if(this.manutencao.status == null){
                    this.manutencao.status = false
                }
                this.axios.post(`admin/servicos`,
                    this.manutencao
                ).then(res => {
                    this.novaManutencao = false
                    this.manutencao.datainicial = null
                    this.manutencao.datafinal = null
                    this.manutencao.horainicial = null
                    this.manutencao.horafinal = null
                    this.manutencao.status = null
                    this.manutencao.justificativa = null
                    this.AlertbarShow = {
                        color: 'green',
                        show: true,
                        time: 10000,
                        text: res.data,
                        bottom: false,
                        right: true,
                        multi: true
                    }
                    this.getManutencao()
                    this.getManutencaoAtiva()
                }).catch(e => {
                    this.AlertbarShow = {
                        color: 'red',
                        show: true,
                        time: 10000,
                        text: e.response.data,
                        bottom: false,
                        right: true,
                        multi: true
                    }
                }).finally(() => {
                    this.progress = false
                })
            },
            editarManutencao(id){
                this.novaManutencao = true
                this.btnManutencaoEditar = true

                this.manutencoes.map(elem => {
                    if(elem.IdManutencao == id){
                        this.manutencao.id = elem.IdManutencao
                        this.manutencao.datainicial = elem.DataInicial
                        this.manutencao.horainicial = elem.HoraInicial
                        this.manutencao.datafinal = elem.DataFinal
                        this.manutencao.horafinal = elem.HoraFinal
                        this.manutencao.status = elem.Status
                        this.manutencao.justificativa = elem.Justificativa

                    }
                })
            },
            atualizarManutencao(id){
                this.progress = true
                this.axios.put(`admin/servicos/${id}`, this.manutencao).then(res => {
                    this.novaManutencao = false
                    this.btnManutencaoEditar = null
                    this.manutencao.datainicial = null
                    this.manutencao.datafinal = null
                    this.manutencao.horainicial = null
                    this.manutencao.horafinal = null
                    this.manutencao.status = null
                    this.manutencao.justificativa = null
                    this.AlertbarShow = {
                        color: 'green',
                        show: true,
                        time: 10000,
                        text: res.data,
                        bottom: false,
                        right: true,
                        multi: true
                    }
                    this.getManutencao()
                    this.getManutencaoAtiva()
                }).catch(e => {
                    this.AlertbarShow = {
                        color: 'red',
                        show: true,
                        time: 10000,
                        text: e.response.data,
                        bottom: false,
                        right: true,
                        multi: true
                    }
                }).finally(() => {
                    this.progress = false
                })
            },
            encerrarManutencao(id){
                this.manutencoesAtivas.map(elem => {
                    if(elem.IdManutencao == id){
                        this.manutencaoAtiva.id = elem.IdManutencao
                        this.manutencaoAtiva.datainicial = elem.DataInicial
                        this.manutencaoAtiva.horainicial = elem.HoraInicial
                        this.manutencaoAtiva.datafinal = elem.DataFinal
                        this.manutencaoAtiva.horafinal = elem.HoraFinal
                        this.manutencaoAtiva.status = elem.Status
                        this.manutencaoAtiva.justificativa = elem.Justificativa

                    }
                })
                this.manutencaoAtiva.status = false
                this.axios.put(`admin/servicos/${id}`, this.manutencaoAtiva).then(res => {
                    this.manutencaoAtiva.datainicial = null
                    this.manutencaoAtiva.datafinal = null
                    this.manutencaoAtiva.horainicial = null
                    this.manutencaoAtiva.horafinal = null
                    this.manutencaoAtiva.status = null
                    this.manutencaoAtiva.justificativa = null
                    this.AlertbarShow = {
                        color: 'green',
                        show: true,
                        time: 10000,
                        text: res.data,
                        bottom: false,
                        right: true,
                        multi: true
                    }
                    this.getManutencao()
                    this.getManutencaoAtiva()
                }).catch(e => {
                    this.AlertbarShow = {
                        color: 'red',
                        show: true,
                        time: 10000,
                        text: e.response.data,
                        bottom: false,
                        right: true,
                        multi: true
                    }
                }).finally(() => {
                    this.progress = false
                })
            },
            deleteManutencao(id){
                let com = confirm('Deseja remover essa manutenção da lista?')
                if(com){
                    this.axios.delete(`admin/servicos/${id}`).then(res => {
                        this.AlertbarShow = {
                            color: 'green',
                            show: true,
                            time: 10000,
                            text: res.data,
                            bottom: false,
                            right: true,
                            multi: true
                        }
                        this.getManutencao()
                        this.getManutencaoAtiva()
                    }).catch(e => {
                        this.AlertbarShow = {
                            color: 'red',
                            show: true,
                            time: 10000,
                            text: e.response.data,
                            bottom: false,
                            right: true,
                            multi: true
                        }
                    }).finally(() => {
                        this.progress = false
                    })
                }
            },
            checkUser(){
                if(this.$route.path == '/admin' || this.$route.name == 'ManutencaoAdmin'){
                    this.adminManutencao = true
                }else{
                    this.adminManutencao = false
                }
            }
        },
        mounted() {
            this.getManutencao()
            this.getManutencaoAtiva()
            this.checkUser()
        }
    }
</script>

<style scoped>

</style>